module.exports = __webpack_public_path__ + "static/media/Banner1.b89a9683.png";